import React from 'react';
import {Composer, ComposerProps} from 'react-native-gifted-chat';
import {IconButton, useTheme} from 'react-native-paper';
import {setDraftMessage} from '../../../store/slices/chat';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
export function ChatComposer({
  composerProps,
  chatId,
}: {
  composerProps: ComposerProps;
  chatId: string;
}) {
  const dispatch = useAppDispatch();

  const theme = useTheme();
  const draftMessage =
    useAppSelector(state => state.chat.draftMessage[chatId]) || '';

  return (
    <Composer
      {...composerProps}
      placeholder={'Type your message here'}
      onTextChanged={text => {
        // console.info('ontextchanged', text)
        draftMessage !== text &&
          dispatch(setDraftMessage({id: chatId, content: text}));
      }}
      placeholderTextColor={theme.colors.onSurfaceVariant}
      // textInputAutoFocus={true}
      text={draftMessage}
      textInputStyle={{
        ...theme.fonts.default,
        color: theme.colors.onSurface,
        overflow: 'visible',
        padding: 20,
        paddingTop: 0,
        paddingLeft: 60,
        paddingRight: 60,
        // paddingBottom: 40,
        // marginBottom: 20,
        backgroundColor: theme.colors.surface,
        // borderRadius: 30,
      }}
      multiline
      textInputProps={{
        ...composerProps.textInputProps,
      }}
    />
  );
}
